<div class="transaction" data-qa-block="report-info">
  <div class="content">
    <div>
      <p>
        <span data-qa="transaction-date-1">{{
          transaction?.transactionDate | dateAsync: 'DD MMM'
        }}</span>
      </p>
      <span data-qa="transaction-date-2" class="grey-text"
        >{{ transaction?.transactionDate | date: 'yyyy' }} г</span
      >
    </div>

    <div class="content__main">
      <ng-container *ngIf="transaction?.type === reportType.xReport; else xreport">
        <div data-qa="report-name">
          {{ 'transaction.shift.number' | translate }} {{ transaction?.shiftNumber }}
        </div>
      </ng-container>
      <ng-template #xreport>
        <div data-qa="report-name">
          {{ 'transaction.close.shift' | translate }} {{ transaction?.shiftNumber }}
        </div>
      </ng-template>
      <tax-transaction-report-totals
        *ngIf="transaction?.type === reportType.zReport; else xReportTotals"
        [transactionTotalResult]="transactionTotalResult"
      ></tax-transaction-report-totals>
      <ng-template #xReportTotals>
        <div class="grey-text x-report-detail">
          <span data-qa="total"
            >{{ 'kkms.kkm.report.tickets.count' | translate }}
            {{ transaction?.ticketCount?.total }}</span
          >
          <span data-qa="cash"
            >{{ 'kkms.kkm.report.tickets.cash' | translate }}
            {{ transaction?.cash | kzCurrency }}</span
          >
          <span data-qa="revenue"
            >{{ 'kkms.kkm.report.tickets.revenue' | translate }}
            {{ transaction?.revenue | kzCurrency }}</span
          >
        </div>
      </ng-template>
    </div>

    <div class="content__desc">
      <tax-transaction-report-sum
        *ngIf="transaction?.type === reportType.zReport; else simpleSum"
        [transactionTotalResult]="transactionTotalResult"
      ></tax-transaction-report-sum>
      <ng-template #simpleSum>
        <p data-qa="buy">
          {{ 'kkms.kkm.report.nonNullableSum.buy' | translate }}
          {{ transaction?.nonNullableSums?.buy | kzCurrency }}
        </p>
        <p data-qa="sells">
          {{ 'kkms.kkm.report.nonNullableSum.sells' | translate }}
          {{ transaction?.nonNullableSums?.sells | kzCurrency }}
        </p>
        <p data-qa="buy-returns">
          {{ 'kkms.kkm.report.nonNullableSum.buyReturns' | translate }}
          {{ transaction?.nonNullableSums?.buyReturns | kzCurrency }}
        </p>
        <p data-qa="sell-returns">
          {{ 'kkms.kkm.report.nonNullableSum.sellReturns' | translate }}
          {{ transaction?.nonNullableSums?.sellReturns | kzCurrency }}
        </p>
      </ng-template>
    </div>
  </div>
</div>
